import type { ReactNode } from "react";
import type { Locale } from "./locales";
import { LocaleContext } from "./useLocale";

// Locale travels by context rather than by prop. A page composes sections, and
// sections compose cards; threading a `locale` prop down that tree would force
// every intermediate component to declare a parameter it does not use, which is
// the locale set leaking into modules that have no reason to know it exists.
export function LocaleProvider({
  locale,
  children,
}: {
  locale: Locale;
  children: ReactNode;
}): JSX.Element {
  return <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>;
}
